<template>
<div>
    {{ counter }}
    <button @click="counter++">hello</button>
    <component2 test="yacking" @test123="listener()" />
    <el-table
            :data="array_data"
            style="width: 100%">
            <el-table-column
                v-for = "column in columns"
                v-bind:prop = column.label.toLowerCase()
                v-bind:label = column.label
                v-bind:width = "180"
            >
            </el-table-column>
        <!--
        <el-table-column
                prop="rule_id"
                label="Rule ID"
                width="180">
        </el-table-column>
        <el-table-column
                prop="name"
                label="Name"
                width="180">
        </el-table-column>
        <el-table-column
                prop="bucket"
                label="Bucket"
                width="180">
        </el-table-column>
        <el-table-column
                prop="disposition"
                label="Disposition"
                width="180">
        </el-table-column>
        <el-table-column
                prop="resourcing"
                label="Resourcing"
                width="180">
        </el-table-column>
        -->
    </el-table>
</div>
</template>

<script>
    import component2 from './component2.vue'
    export default {
        mounted() {
            console.log('Component mounted now.')
            axios.get('/api/flattened/json/4')
                .then(response => {
                    this.array_data = response.data
                    console.log(this.array_data)
                })
                .catch(error => {
                    console.log('oops')
                })
            axios.get('/api/flattened/json/4/columns')
                .then(response => {
                    this.columns = response.data
                })
                .catch(error => {
                    console.log('oops')
                })
        },
        data() {
            return {
                counter: 0,
                columns: [{prop: 'rule_id', label:'Rule ID', width: 180},{prop: 'name', label: 'Name', width: 180}],
                array_data:[]
        }},
        components: {component2},
        methods: { listener() {
            console.log('listen')
        }}
    }
</script>
